import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=60f35ab6&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=60f35ab6&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f35ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelwang/Career/JiaLin_Project/meow-admin-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f35ab6')) {
      api.createRecord('60f35ab6', component.options)
    } else {
      api.reload('60f35ab6', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=60f35ab6&scoped=true", function () {
      api.rerender('60f35ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/Layout.vue"
export default component.exports